export default __webpack_public_path__ + "static/media/bg-chat-tile-dark.39f53e74.png";